import {
    Component,
    Input,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Address } from '../../../core/store/models';

@Component({
    selector: 'ah-address-input',
    templateUrl: './address-input.component.html',
    styleUrls: ['./address-input.component.scss'],
    standalone: false
})
export class AddressInputComponent {
    @Input() address: Address;
    @Input() loanAddress: Address;
    @Input() addressName: string;
    @Input() formGroup: UntypedFormGroup;
    @Input() formGroupName: string;

    constructor() { }
}
